import { render, staticRenderFns } from "./Projection.vue?vue&type=template&id=4bcf1b01&"
import script from "./Projection.vue?vue&type=script&lang=js&"
export * from "./Projection.vue?vue&type=script&lang=js&"
import style0 from "./Projection.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports